module.exports = __webpack_public_path__ + "static/media/27_A.d2b4174d.png";